export default __webpack_public_path__ + "static/media/headshot-nov2020-resize.f3c097f2.jpg";